<template>
  <!-- 底部 -->
  <div class="footer">
    <div class="footer_top">
      <a href="http://company.drcnet.com.cn/about.html" target="_blank" rel="noopener noreferrer">关于我们</a>
      <span>|</span>
      <a href="http://misc.drcnet.com.cn/us/wangzsm.aspx" target="_blank" rel="noopener noreferrer">网站声明</a>
      <span>|</span>
      <a href="http://company.drcnet.com.cn/lxwm.html" target="_blank" rel="noopener noreferrer">联系我们</a>
      <span>|</span>
      <a href="http://www.drcnet.com.cn/www/int/" target="_blank" rel="noopener noreferrer">公司网站</a>
      <span>|</span>
      <img src="@/assets/img/3-1.png" alt class="phone" />
      <span>热线电话：400-7070-678</span>
    </div>
    <div class="footer_bottom">Copyright©1998-{{nowYear}} DRCNet. All Rights Reserved 版权所有 国研网</div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      nowYear: ""
    };
  },
  methods: {
    // 获取本地年份
    addDate() {
      let year = new Date().getFullYear();
      this.nowYear = year;
    }
  },
  created() {
    this.addDate();
  }
};
</script>

<style scoped lang="less">
/* 底部 */
.footer {
  width: 100%;
  height: 60px;
  background: #054dc6;
  display: flex;
  flex-direction: column;
  padding-top: 5px;
  padding-bottom: 5px;
}

.footer_top {
  width: 100%;
  height: 24px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #c9dfff;
  line-height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  a{
    padding: 7px;
    color: #c9dfff;
  }
  span {
    padding: 7px;
  }
  .phone {
    transform: translate(13%, 0);
    padding-left: 5px;
    width: 18px;
    height: 18px;
  }
}
.footer_bottom {
  width: 100%;
  height: 24px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #c9dfff;
  line-height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}
</style>





// WEBPACK FOOTER //
// src/components/footer2.vue